import * as React from "react";

const Warning: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17.982" height="16.088" viewBox="0 0 17.982 16.088">
            <g id="Icon" transform="translate(0.771)">
                <rect id="Area" width="16" height="16" transform="translate(-0.038)" fill="#fcfcfc" opacity="0" />
                <g id="Icon-2" data-name="Icon" transform="translate(0.001 1.099)">
                    <path id="aacf51fe-c9d9-4e8d-953f-6a1994ce5a1e" d="M8.359,3.53,1.7,14.653a1.573,1.573,0,0,0,1.345,2.359H16.366a1.572,1.572,0,0,0,1.345-2.359L11.049,3.53a1.573,1.573,0,0,0-2.69,0Z" transform="translate(-1.486 -2.773)" fill="none" stroke="#89483b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                    <line id="c699d66e-77fe-442b-861c-40694e1a3354" y2="3.146" transform="translate(8.218 4.8)" fill="none" stroke="#89483b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                    <line id="_8e5b2db5-852d-4022-bcdb-c4ba1d9b607d" data-name="8e5b2db5-852d-4022-bcdb-c4ba1d9b607d" x2="0.008" transform="translate(8.218 11.093)" fill="none" stroke="#89483b" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(Warning);
